import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    isSummaryPopupVisible: false,
    wardrobeSettings: {
      maxHeight: 2750,
      maxWidth: 5000,
      minHeight: 2048,
      minWidth: 1200
    }
  },
  mutations: {
    setIsSummaryPopupVisible (state, isSummaryPopupVisible) {
      Vue.set(state, 'isSummaryPopupVisible', isSummaryPopupVisible);
    }
  },
  getters: {
    isSummaryPopupVisible: (state) => state.isSummaryPopupVisible,
    wardrobeMaxHeight: (state) => state.wardrobeSettings.maxHeight,
    wardrobeMaxWidth: (state) => state.wardrobeSettings.maxWidth,
    wardrobeMinHeight: (state) => state.wardrobeSettings.minHeight,
    wardrobeMinWidth: (state) => state.wardrobeSettings.minWidth,
  }
};
